import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-352745ad"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "details-form__item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tags_selection = _resolveComponent("tags-selection")!
  const _component_malt_classic_expertise_side = _resolveComponent("malt-classic-expertise-side")!
  const _component_step = _resolveComponent("step")!

  return (_openBlock(), _createBlock(_component_step, {
    "is-step-valid": _ctx.hasValidFieldPart,
    onGoToNext: _ctx.goNext
  }, {
    "step-content": _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_tags_selection)
      ])
    ]),
    "step-side": _withCtx(() => [
      _createVNode(_component_malt_classic_expertise_side)
    ]),
    _: 1
  }, 8, ["is-step-valid", "onGoToNext"]))
}